const ErrorRoute = () => {
  throw new Error('Unexpected route');
};

export default ErrorRoute;
